import { ReactNode } from 'react';

import { ComponentColumn, ComponentColumns } from '../component.constants';
import {
  getAppliedColour,
  isBackgroundApplied,
  isBorderApplied,
} from './settings/column-settings.utils';
import * as Styled from 'approot/activity-builder/components/columns/columns-print.style';

type Props = {
  columns: ComponentColumn[];
  columnProperties: ComponentColumns['columnProperties'] | null;
  render: (column: ComponentColumn) => ReactNode;
};

const ColumnsPrintWrapper = ({ columns, columnProperties, render }: Props) => {
  return (
    <Styled.ColumnsPrintContainer
      $colours={getAppliedColour(columnProperties?.style)}
      $showBackground={isBackgroundApplied(columnProperties?.style)}
      $showBorder={isBorderApplied(columnProperties?.style)}
      $turnOffResponsive
    >
      {columns?.map(column => (
        <Styled.ColumnsPrintColumn
          key={column.columnId}
          $colspan={column.colspan}
          $alignment={column.alignment}
          $colours={getAppliedColour(column.style)}
          $showBorder={isBorderApplied(column.style)}
          $showBackground={isBackgroundApplied(column.style)}
          $turnOffResponsive
        >
          {render(column)}
        </Styled.ColumnsPrintColumn>
      ))}
    </Styled.ColumnsPrintContainer>
  );
};

export default ColumnsPrintWrapper;
